import * as z from 'zod';

export const TaskStatus = z.enum(['open', 'closed_success', 'closed_fail']);
export type TaskStatus = z.infer<typeof TaskStatus>;

export const TaskAttributesV2 = z.object({
  code: z.string(),
  title: z.string(),
  owner_full_name: z.string(),
  owner_email: z.string(),
  owner_id: z.number(),
  created_at: z.number(),
  closed_at: z.number().nullable(),
  updated_at: z.number(),
  due_at: z.number(),
  description: z.string().optional(),
  issue_code: z.string(),
  issue_id: z.number(),
  time_limit: z.preprocess((val) => Number(val), z.number()),
  due_date: z.string().optional().nullable(),
  creator_id: z.number(),
  creator_email: z.string(),
  creator_full_name: z.string(),
  issue_step_id: z.number().nullable(),
  status: z.string(),
});

export const TaskV2 = z.object({
  attributes: TaskAttributesV2,
  type: z.string(),
  id: z.number(),
});

export type TaskV2 = z.infer<typeof TaskV2>;

export const TaskListResponse = z.object({
  data: z.array(TaskV2),
  meta: z.object({
    totalItems: z.number(),
    totalPages: z.number(),
  }),
});

export type TaskListResponse = z.infer<typeof TaskListResponse>;

export const TasksRequest = z.object({
  event_type: z.string().optional(),
  term: z.string().optional(),
  created_at_start_date: z.string().optional(),
  created_at_end_date: z.string().optional(),
  order_by: z.string().optional(),
  is_overdue: z.string().optional(),
  product_id: z.string().optional(),
  rootcause_id: z.string().optional(),
  status: z.array(TaskStatus).optional(),
  owner_id: z.string().optional(),
  page_number: z.number().optional(),
  page_size: z.number().optional(),
  filter_by_issue_step_ids: z.string().optional(),
  offset: z.number().optional(),
  limit: z.number().optional(),
});

export type TasksRequest = z.infer<typeof TasksRequest>;

export const TaskUpdateResponse = z.object({
  id: z.string(),
  title: z.string(),
  owner_full_name: z.string(),
  owner_id: z.number(),
  created_at: z.string(),
  closed_at: z.string().nullable(),
  updated_at: z.string(),
  due_at: z.string(),
  description: z.string().optional(),
  time_limit: z.coerce.number(),
  creator_id: z.number(),
  creator_full_name: z.string(),
  issue_step_id: z.number(),
  status: z.string(),
  type: z.string(),
});

export type TaskUpdateResponse = z.infer<typeof TaskUpdateResponse>;
